import * as ActionTypes from 'constants';

export const pipeline = ( state = {
  pipeline : null,
  summary : [],
}, action) => {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SAVE_PIPELINE:
      return {
        ...state,
        saving : true,
      }
    case ActionTypes.CREATE_PIPELINE_SUCCESS:
      return {
        ...state,
        pipeline : payload.pipeline,
        saving : false
      }
    case ActionTypes.UPDATE_PIPELINE_SUCCESS:
      return {
        ...state,
        pipeline : payload.pipeline,
        saving : false
      }
    case ActionTypes.UPDATE_PIPELINE_FAILED: case ActionTypes.CREATE_PIPELINE_FAILED:
      return {
        ...state,
        saving : false
      }
    case ActionTypes.FETCH_PIPELINE:
      return {
        ...state,
        fetching : true,
      }
    case ActionTypes.FETCH_PIPELINE_SUCCESS:
      return {
        ...state,
        pipeline : payload.pipeline,
        fetching: false,
      }
    case ActionTypes.FETCH_PIPELINE_FAILED:
      return {
        ...state,
        fetching : false
      }
    case ActionTypes.UPDATE_PIPELINE_SUMMARY:
      return {
        ...state,
        summary : action.payload.summary
      }
      break;
    default:
      return {...state};
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/common/reducers/pipeline.js